import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfRequisicaoExames.scss";
import moment from "moment/moment";

function PdfRequisicaoExames({ showPreviousPage, requisicaoData }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Requisicao-Exames-${requisicaoData.cliente.nome}_${moment(
      new Date(),
    ).format("DD-MM-YYYY")}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  const calcularIdade = () => {
    if (!requisicaoData.cliente?.data_nasc) return { anos: 0, meses: 0 };
    const dtNascTemp = moment(requisicaoData.cliente.data_nasc, "DD-MM-YYYY");

    let anos = moment().year() - dtNascTemp.year();
    let meses = moment().month() - dtNascTemp.month();

    if (meses < 0) {
      anos--;
      meses += 12;
    }

    return { anos, meses };
  };

  const idade = calcularIdade(requisicaoData.cliente.data_nasc);

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-requisicao-wrapper ${requisicaoData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""}`}
      >
        <div className="pdf-requisicao-cabecalho">
          <div className="pdf-requisicao-cabecalho-left">
            <img
              src={`${process.env.REACT_APP_BACKEND_LINK}/${requisicaoData.clinica.logotipo}`}
              alt=""
            />
          </div>

          <div className="pdf-requisicao-cabecalho-right">
            <span>{requisicaoData.clinica.nome}</span>
            <span>
              {requisicaoData.medico_responsavel.genero === "masculino"
                ? "Dr. "
                : "Dra. "}
              {requisicaoData.medico_responsavel.name}/
              {requisicaoData.medico_responsavel.profissao}
            </span>
            <span>
              Telef: {requisicaoData.clinica.contacto}{" "}
              {requisicaoData.clinica.contacto2
                ? "/" + requisicaoData.clinica.contacto2
                : ""}
              {requisicaoData.clinica.contacto3
                ? "/" + requisicaoData.clinica.contacto3
                : ""}
            </span>
            <span>{requisicaoData.clinica.endereco}</span>
            <span>NIF: {requisicaoData.clinica.nif}</span>
          </div>
        </div>

        {/* DADOS DO PACIENTE */}
        <div className="pdf-requisicao-dados-cliente">
          <div className="campo-linha">
            <span className="label-campo label-campo--primeiroLabel">
              Nome:
            </span>
            <span className="valor-campo">{requisicaoData.cliente.nome}</span>
          </div>

          <div className="campo-linha">
            <span className="label-campo label-campo--primeiroLabel">
              D. Nasc:
            </span>
            <span className="valor-campo">
              {requisicaoData.cliente.data_nasc}
            </span>

            <span className="label-campo">Anos:</span>
            <span className="valor-campo">{idade.anos}</span>

            <span className="label-campo">Meses:</span>
            <span className="valor-campo">{idade.meses}</span>

            <span className="label-campo">Sexo:</span>
            <span className="valor-campo">{requisicaoData.cliente.genero}</span>

            <span className="label-campo">Naturalidade:</span>
            <span className="valor-campo">{requisicaoData.naturalidade}</span>
          </div>

          <div className="campo-linha campo-linha-dupla">
            <span className="label-campo label-campo--primeiroLabel">
              Morada:
            </span>
            <span className="valor-campo">
              {requisicaoData.cliente.endereco}
            </span>

            <span className="label-campo">Procedência:</span>
            <span className="valor-campo">{requisicaoData.procedencia}</span>
          </div>

          <div className="campo-linha">
            <span className="label-campo label-campo--primeiroLabel">
              Diagnóstico:
            </span>
            <span className="valor-campo">{requisicaoData.diagnostico}</span>
          </div>
        </div>

        {/* SEÇÃO SANGUE */}
        <div className="pdf-requisicao-secao">
          <h3 className="secao-titulo">SANGUE</h3>

          <div className="exames-grid-sangue">
            {/* Coluna 1 */}
            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.glVermelhos}
                readOnly
              />
              <span>Gl. vermelhos</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.glVermelhosNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.velSedimentacao}
                readOnly
              />
              <span>Vel. Sedimentação</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.velSedimentacaoNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.glBrancos}
                readOnly
              />
              <span>Gl. brancos</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.glBrancosNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.tHemorragia}
                readOnly
              />
              <span>T. Hemorragia</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.tHemorragiaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.hemoglobina}
                readOnly
              />
              <span>Hemoglobina</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.hemoglobinaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.tCoagulacao}
                readOnly
              />
              <span>T. Coagulação</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.tCoagulacaoNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.hematocrito}
                readOnly
              />
              <span>Hematócrito</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.hematocritoNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.plaquetas}
                readOnly
              />
              <span>Plaquetas</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.plaquetasNota}
              </div>
            </div>

            {/* Fórmula com subcampos */}
            <div className="exame-item exame-formula">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.formula}
                readOnly
              />
              <span>Fórmula (%)</span>
              {/* {requisicaoData.examesSangue.formula && ( */}
              <div className="formula-detalhes">
                <span>Neut: {requisicaoData.examesSangue.formulaNeut}</span>
                <span>Eosin: {requisicaoData.examesSangue.formulaEosin}</span>
                <span>Bas: {requisicaoData.examesSangue.formulaBas}</span>
                <span>Linf: {requisicaoData.examesSangue.formulaLinf}</span>
                <span>Mon: {requisicaoData.examesSangue.formulaMon}</span>
                <span>N.J: {requisicaoData.examesSangue.formulaNj}</span>
              </div>
              {/* )}*/}
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.pesqPlasmedio}
                readOnly
              />
              <span>Pesq. Plasmódio</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.pesqPlasmedioNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.hiv}
                readOnly
              />
              <span>HIV 1/2</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.hivNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.hbsAg}
                readOnly
              />
              <span>HBS Ag</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.hbsAgNota}
              </div>
            </div>

            {/* Segunda linha de exames */}
            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.glicemia}
                readOnly
              />
              <span>Glicémia</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.glicemiaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.acidoUrico}
                readOnly
              />
              <span>Ácido Úrico</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.acidoUricoNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.amilase}
                readOnly
              />
              <span>Amilase</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.amilaseNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.got}
                readOnly
              />
              <span>GOT</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.gotNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.bilirrTotal}
                readOnly
              />
              <span>Bilirr. Total</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.bilirrTotalNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.gamaGt}
                readOnly
              />
              <span>Gama GT</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.gamaGtNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.gpt}
                readOnly
              />
              <span>GPT</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.gptNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.bilirrDirecta}
                readOnly
              />
              <span>Bilirr. Directa</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.bilirrDirectaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.fosfAlcalina}
                readOnly
              />
              <span>Fosf. Alcalina</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.fosfAlcalinaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.colesterol}
                readOnly
              />
              <span>Colesterol</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.colesterolNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.ureia}
                readOnly
              />
              <span>Ureia</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.ureiaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.colLdl}
                readOnly
              />
              <span>Col. LDL</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.colLdlNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.triglicerideos}
                readOnly
              />
              <span>Triglicerídeos</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.triglicerideosNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.colHdl}
                readOnly
              />
              <span>Col. HDL</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.colHdlNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.creatinina}
                readOnly
              />
              <span>Creatinina</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.creatininaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.vdrl}
                readOnly
              />
              <span>VDRL</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.vdrlNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.tpha}
                readOnly
              />
              <span>TPHA</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.tphaNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.widal}
                readOnly
              />
              <span>WIDAL</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.widalNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.pcr}
                readOnly
              />
              <span>PCR</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.pcrNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.taso}
                readOnly
              />
              <span>TASO</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.tasoNota}
              </div>
            </div>

            <div className="exame-item">
              <input
                type="checkbox"
                checked={requisicaoData.examesSangue.frRa}
                readOnly
              />
              <span>FR/RA</span>
              <div className="nota-linha">
                {requisicaoData.examesSangue.frRaNota}
              </div>
            </div>
          </div>
        </div>

        {/* SEÇÃO URINA */}
        <div className="pdf-requisicao-secao">
          <h3 className="secao-titulo">URINA</h3>

          <div className="exames-urina">
            <div className="exame-urina-linha">
              <input
                type="checkbox"
                checked={requisicaoData.examesUrina.caracteresGerais}
                readOnly
              />
              <span className="exame-label">Caracteres gerais</span>
              <div className="linha-tracejada">
                {requisicaoData.examesUrina.caracteresGeraisNota}
              </div>
            </div>

            <div className="exame-urina-campos">
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.glicosuria}
                  readOnly
                />
                <span>Tira: Glicosúria</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.glicosuriaNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.albumina}
                  readOnly
                />
                <span>Albumina</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.albuminaNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.densidade}
                  readOnly
                />
                <span>Densidade</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.densidadeNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.ph}
                  readOnly
                />
                <span>pH</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.phNota}
                </div>
              </div>
            </div>

            <div className="exame-urina-campos">
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.acetona}
                  readOnly
                />
                <span>Acetona</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.acetonaNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.bilirr}
                  readOnly
                />
                <span>Bilirr.</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.bilirrNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.leucocitos}
                  readOnly
                />
                <span>Leucócitos</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.leucocitosNota}
                </div>
              </div>
              <div className="exame-urina-item">
                <input
                  type="checkbox"
                  checked={requisicaoData.examesUrina.sangue}
                  readOnly
                />
                <span>Sangue</span>
                <div className="campo-pequeno-linha">
                  {requisicaoData.examesUrina.sangueNota}
                </div>
              </div>
            </div>

            <div className="exame-urina-linha">
              <input
                type="checkbox"
                checked={requisicaoData.examesUrina.sedimento}
                readOnly
              />
              <span className="exame-label">Sedimento</span>
              <div className="linha-tracejada">
                {requisicaoData.examesUrina.sedimentoNota}
              </div>
            </div>
          </div>
        </div>

        {/* SEÇÃO FEZES */}
        <div className="pdf-requisicao-secao">
          <h3 className="secao-titulo">FEZES</h3>

          <div className="exames-fezes">
            <div className="exame-fezes-linha">
              <input type="checkbox" checked={requisicaoData.fezes} readOnly />
              <div className="linha-tracejada-longa">
                {requisicaoData.fezesNota}
              </div>
            </div>
          </div>
        </div>

        {/* RODAPÉ COM DATAS E ASSINATURAS */}
        <div className="pdf-requisicao-rodape">
          <div className="datas-container">
            <div className="data-campo">
              <span className="data-label">DATA</span>
              <span className="data-valor">
                {moment(requisicaoData.dataRequisicao).format("DD/MM/YYYY")}
              </span>
            </div>
            <div className="data-campo">
              <span className="data-label">DATA COLHEITA</span>
            </div>
          </div>

          <div className="assinaturas-container">
            <div className="assinatura-campo">
              <span className="assinatura-titulo">O MÉDICO</span>
              <div className="assinatura-linha">
                {requisicaoData.medico_responsavel.name}
              </div>
            </div>
            <div className="assinatura-campo">
              <span className="assinatura-titulo">O TÉCNICO</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PdfRequisicaoExames;
